import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { DataService } from '../app-service/data.service';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';

const datas = []; // global variable declaration so can be used by all classes

@Component({
  selector: 'app-app-header',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.css']
})
export class AppHeaderComponent implements OnInit {

  // @output decorator to send output to parent when the event occured.
  @Output() formatDetails = new EventEmitter();
  @Output() formatSizeDetails = new EventEmitter();

  // This section contains the functions for the typeAhead search combo box.
  // local declarations
  public model: any;
  public buttonName = 'Sort by size';
  
  search = (text$: Observable<string>) =>
    text$
      .debounceTime(200)
      .map(term => term.length < 2 ? []
        : datas.filter(v => v.title.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))

  formatter = (x: { title: string }) => x.title;

  // Envoked when a data from sort by size menue is came or a button from the same is clicked.
  public buttonNameMethod(x, y) {
    this.buttonName = x + ' - ' + y;
    if (y === '') {
      this.buttonName = x;
    } else {
      const tempstr = x + '>' + y;
      this.formatSizeDetails.emit(tempstr);
    }
    
  }


  // Getting data from json file and toring it in datas global variable
  public getData() {
    this._dataService
      .getData('../assets/jsonData/formatData.json')
      .subscribe(res => {
        const x = res.json();
        for (const type in x[0]) {
          if (type != null) {
            for (const size in x[0][type]) {
              if (size != null) {
                for (let i = 0; i < x[0][type][size].length; i++) {
                  x[0][type][size][i]['type'] = type;
                  x[0][type][size][i]['size'] = size;
                  datas.push(x[0][type][size][i]);
                }
              }
            }
          }
        }
        
      }, error => {
        console.log(error);
      });
  }

  // open url from the mentioned link in toggler menue
  public openUrl(url) {
    window.open(url, '_blank');
  }

  // Envoked when an item is being selected from typeAhead box.
  public reflect(type, size, name) {
    const tempstr = type + '>' + size + '>' + name;
    this.formatDetails.emit(tempstr);
  }

  // getting local variable for dataservice so that it can be accessiable to the class members.
  constructor(private _dataService: DataService) {
  }

  ngOnInit() {
    this.getData(); // On page load it start the execution to get the desired data.
    this._dataService.currentbuttonName.subscribe(name => this.buttonName = name)
    console.log(this._dataService);
  }

}



// WEBPACK FOOTER //
// /home/ubuntu/demo.airtory.com-stage/src/app/app-header/app-header.component.ts